import StylishNewComboBox, {
  type ComboBoxOption,
} from 'components/DesignSystems/New/StylishNewComboBox';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

type AddChildRowProps = {
  options: ComboBoxOption[];
  placeholder: string;
  onCreate: (label: string) => void;
  onCancel: () => void;
  customInputMaxLength?: number;
};

const AddChildRow: React.FC<AddChildRowProps> = ({
  options,
  placeholder,
  onCreate,
  onCancel,
  customInputMaxLength,
}) => (
  <div className="d-flex align-items-center gap-2">
    <StylishNewComboBox
      classes="flex-grow-1"
      options={options}
      placeholder={placeholder}
      customOptionLabel="+ Create New"
      customInputMaxLength={customInputMaxLength}
      onChange={(v) => {
        const opt = v as ComboBoxOption | null;
        if (opt) onCreate(opt.label);
      }}
    />
    <StylishNewButton className="button--icon" onClick={onCancel}>
      <SharedIcon iconName="close" />
    </StylishNewButton>
  </div>
);

export default AddChildRow;
